exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* file-upload */\n.sc-ndaFileUpload .input-radio-wrapper[data-v-6fb2bfc0] {\n  padding-right: 10px;\n}\n.sc-ndaFileUpload .row[data-v-6fb2bfc0] {\n  display: flex;\n}\n.sc-ndaFileUpload .row .control-wrapper[data-v-6fb2bfc0] {\n  overflow: hidden;\n}\n.sc-ndaFileUpload .nda-file-upload-wrapper input[data-v-6fb2bfc0] {\n  vertical-align: middle;\n}\n.sc-ndaFileUpload .nda-file-select-document-wrapper[data-v-6fb2bfc0] {\n  padding-top: 20px;\n}\n.sc-ndaFileUpload .input-radio-wrapper.disabled[data-v-6fb2bfc0] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n", ""]);

// exports
